import React, { useRef } from 'react';
import RugbyFieldSVG from '../../common/RugbyFieldSVG';
import { useTheme } from '../../../hooks/useTheme';

/**
 * Component for displaying the rugby field and handling field clicks
 */
const RugbyField = ({
  events,
  homeTeamName,
  awayTeamName,
  handleDirectFieldClick,
  teamDirection = 'left-to-right'
}) => {
  // Reference to the pitch container
  const pitchContainerRef = useRef(null);
  // Access current theme
  const { theme } = useTheme();

  // Get only the last 10 events for displaying on the field
  const lastTenEvents = events.slice(-10);

  // Apply theme-specific classes
  const pitchWrapperClass = `pitch-wrapper ${theme === 'high-contrast' ? 'high-contrast' : ''}`;
  const pitchContainerClass = `pitch-container ${theme === 'high-contrast' ? 'high-contrast' : ''}`;

  return (
    <div className={pitchWrapperClass}>
      <div
        className={pitchContainerClass}
        ref={pitchContainerRef}
        onClick={handleDirectFieldClick}
      >
        <div className="rugby-field">
          <RugbyFieldSVG teamDirection={teamDirection}>
            {/* Event Markers - Only showing last 10 events */}
            {lastTenEvents.map((event, index) => {
              // Calculate the display number based on its position in the full events array
              const displayNumber = events.indexOf(event) + 1;
              
              // Add theme-awareness to markers
              const markerColor = event.team === 'Home' 
                ? 'var(--home-team-color)' 
                : 'var(--away-team-color)';
              
              // Adjust stroke based on theme
              const strokeColor = theme === 'high-contrast' ? 'white' : 'white';
              const strokeWidth = theme === 'high-contrast' ? '1' : '0.5';
              
              return (
                <g
                  key={event.id}
                  transform={`translate(${event.position.x * 120}, ${event.position.y * 70})`}
                >
                  <circle
                    r={theme === 'high-contrast' ? '1.5' : '1'}
                    fill={markerColor}
                    stroke={strokeColor}
                    strokeWidth={strokeWidth}
                  >
                    <title>{`${event.eventType} - ${event.team === 'Home' ? homeTeamName : awayTeamName} - ${event.timestamp}`}</title>
                  </circle>
                  <text
                    x="0"
                    y="0"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fill={theme === 'high-contrast' ? 'black' : 'white'}
                    fontSize={theme === 'high-contrast' ? '1.5' : '1'}
                    fontWeight="bold"
                  >
                    {displayNumber}
                  </text>
                </g>
              );
            })}
          </RugbyFieldSVG>
        </div>
      </div>
    </div>
  );
};

export default RugbyField;